import CryptoJS from 'crypto-js'
const hashString = {
  encrypt(value: string, secretKey?: string): string {
    if (!secretKey) return value
    const encryptedString = CryptoJS.AES.encrypt(value, secretKey).toString()
    return encryptedString
  },
  decrypt(value: string, secretKey?: string): string {
    if (!secretKey) return value
    const bytes = CryptoJS.AES.decrypt(value, secretKey)
    const decryptedString = bytes.toString(CryptoJS.enc.Utf8)
    return decryptedString
  }
}
export default hashString